"use client";

import { useTranslations } from "next-intl";
import MuiLink from "@mui/material/Link";
import { Link } from "@/i18n/navigation";
import { navLabelSx } from "@/theme/tokens";

/**
 * Simple page links (Work, About) that sit alongside the expanding mega menus
 * in the header. Kept as a client component so the locale-aware next-intl
 * `Link` can be passed to MUI's Link, which the server-rendered Header cannot
 * do across the server/client boundary.
 */
const PAGES = [
  { href: "/work", key: "work" },
  { href: "/about", key: "about" },
] as const;

export function HeaderPageLinks() {
  const t = useTranslations("header");
  return (
    <>
      {PAGES.map(({ href, key }) => (
        <MuiLink
          key={href}
          component={Link}
          href={href}
          underline="none"
          sx={{
            ...navLabelSx,
            whiteSpace: "nowrap",
            color: "text.secondary",
          }}
        >
          {t(`nav.${key}`)}
        </MuiLink>
      ))}
    </>
  );
}
